<template>
  <div class="trims-accessories-container">
    <div class="trims-accessories-header-wrapper">
      <h2>{{ $resourceString["trimsaccessories.header"] }}</h2>
      <h5 class="localRepDisclaimer">
        {{ $resourceString['trimsaccessories.contactManagerText'] }}
        <a class="hyperlinkStyle" @click="contactManager()">
          {{ $resourceString['trimsaccessories.contactManagerAnchorText']}}
        </a>
      </h5>
    </div>
    <div class="container-fluid">
      <div id="vue-wf-product-category">


        <!-- Filters and Controls -->
        <div class="wf-page-controls mt-4 mt-lg-0">
          <div class="wf-page-controls-items">
            <div class="wf-page-control-item wf-page-control-item-current-refinements">
              <current-filters/>
            </div>
            <div class="wf-page-control-item wf-page-control-item-product-display-controls">
              <pc-trims-accessories-controls />
            </div>
          </div>
        </div>

        <!-- Filters and Results -->
        <div class="wf-product-category">

          <!-- Filters (mobile) -->
          <div class="wf-product-category-sidebar-mobile">
            <div class="wf-side-collapse" id="filters-side-collapse">
              <div class="wf-side-collapse-header justify-content-end">
                <button class="wf-side-collapse-button wf-side-collapse-button-close btn" type="button">
                  {{ $resourceString["product.search.close.button"] }}
                  <span class="png-icon png-icon-icons-glyph--g-close" aria-label="close button" />
                </button>
              </div>
              <div class="wf-side-collapse-body">
                <div class="wf-side-collapse-section">
                  <current-filters/>
                </div>
                <div class="wf-side-collapse-section">
                  <side-filters />
                </div>
              </div>
            </div>
          </div>

          <!-- Filters (desktop) -->
          <div class="wf-product-category-sidebar-desktop filtersMargin">
            <side-filters />
          </div>

          <!-- Results -->
          <div class="wf-product-category-results">
            <section class="wf-product-category-results-section">
              <div class="container-fluid">
                <h2 class="secondary-heading">
                  Styles
                </h2>
                <div class="wf-product-category-results">
                  <div class="wf-product-category-results">
                    <div class="wf-search-results" :class="[`wf-search-results-tile-size-${tileSize}`]" :key="tileSize">
                      <div v-for="(item, index) in trimsAndAccessories" :key="index" class="wf-search-result description">
                        <!-- Swiper Container -->
                        <div class="swiper-container" :id="'swiper-' + index" v-wf-swiper="{
                          parameters: {
                            initialSlide: 0,
                            allowTouchMove: false
                          },
                          slideChangeEvent: onSlideChange
                        }">

                          <div class="main-image">
                            <!-- Main Image -->
                            <div class="wf-product-quick-view-swatch-slide">
                              <a class="px-0 w-100 cart-item-model-no">
                                <div class="swatch-slide-image">
                                  <img class="image" :alt="item.trimColors[0].imageAltText || ''" :src="item.trimColors[0].imagePath">
                                </div>
                              </a>
                            </div>
                          </div>
                          <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(trimColor, colorIndex) in item.trimColors"
                              :key="colorIndex">

                              <!-- Description -->
                              <div class="active-color-header position-absolute d-flex flex-column accessoryDescription">
                                <div :style="{ fontWeight: 'bold' }">
                                  {{ `${item.sellingStyleName} ${item.sellingStyleNumber}` }}
                                </div>
                                <div class="trimColors">
                                  {{ `${item.trimColors.length} ${item.trimColors.length !== 1 ? 'colors' : 'color'}` }}
                                  -
                                  {{ `${trimColor.colorName.toLowerCase()}` }}
                                </div>

                                <div class="construction">
                                  {{ item.construction }}
                                </div>

                                <div v-if="item.tearSheetLink">
                                  <a class="learnMore" @click="learnMore(item)">
                                    {{ $resourceString["trimsaccessories.learnMore"] }}
                                  </a>
                                </div>

                                <div v-if="item.specSheetLink">
                                  <a class="learnMore" @click="specSheet(item)">
                                    {{ $resourceString["trimsaccessories.specSheet"] }}
                                  </a>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div class="wf-swiper-thumbnails wf-swiper-thumbnails-with-nav-buttons
                        d-none on-hover-thumbnails ml-3 mr-3 wf-product-thumbnails-size-small thumbSwiper">
                            <!-- Previous Button -->
                            <button v-if="item.trimColors.length > 1"
                              class="wf-swiper-nav-button wf-swiper-nav-button-prev btn btn-full" type="button">
                              <span class="png-icon png-icon-icons-glyph--ko-chevron-left png-size arrow-left mt-1"
                                aria-label="Previous color" />
                            </button>
                            <!-- Thumbnails Container -->
                            <div class="wf-swiper-thumbnails-container">
                              <div class="wf-swiper-thumbnail" v-for="trimColor in item.trimColors">
                                <div class="imageInfo" v-for="imageInfo in trimColor.imagesInfo"
                                  :key="trimColor.colorNumber">
                                  <a class="cart-item-model-no">
                                    <div class="red-underline" />
                                    <img class="image-thumbnail" :alt="imageInfo.imageAltText || ''" :src="imageInfo.url">
                                  </a>
                                </div>
                              </div>
                            </div>
                            <!-- Next Button -->
                            <button v-if="item.trimColors.length > 1"
                              class="wf-swiper-nav-button wf-swiper-nav-button-next btn btn-full" type="button">
                              <span class="png-icon png-icon-icons-glyph--ko-chevron-right arrow-right png-size mt-1"
                                aria-label="Next color" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <p v-if="trimsAndAccessories.length === 0 && !isFetching">
                        {{ $resourceString['common.noResults'] }}
                      </p>
                    </div>
                  </div>
                  <pc-load-more v-if="showLoadMore" :load-more="onLoadMore" />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { initialize } from "../../../scripts/wf-side-collapse";

import PCTrimsAccessoriesControls from './pc-trims-accessories-controls.vue';
import CurrentFilters from '../virtual-tray/pc-vt-search-current-filters.vue';
import SideFilters from './pc-trims-accessories-side-filters.vue'
import PcLoadMore from '../common/pc-loading-more.vue';
import PCGTMEventLogger from "../pc-gtm-event-logger.vue";
import { PRODUCT_IMPRESSION_EVENT_NAME } from "../../../constants/gtm-constants";

export default {
  props: ['initialSelectedFilters'],
  data() {
    return {
      currentColorNumber: null,
      containerHeights: [0],
      currentHeightIndex: 0,
      GTMEventName: PRODUCT_IMPRESSION_EVENT_NAME, //in case GTM is desired
    };
  },
  components: {
    'pc-trims-accessories-controls': PCTrimsAccessoriesControls,
    'current-filters': CurrentFilters,
    'side-filters': SideFilters,
    PcLoadMore,
    "pc-gtm-event-logger": PCGTMEventLogger

  },
  computed: {
    ...mapGetters({
      pageNumber: "trimsAccessories/pageNumber",
      sortOrder: "filters/sortOrder",
      isAscendingOrder: "filters/isAscendingOrder",
      selectedFilters: "filters/selectedFilters",
      pageSize: "trimsAccessories/pageSize",
      isFetching: "trimsAccessories/isFetching",
      showLoadMore: "trimsAccessories/showLoadMore",
      tileSize: "filters/tileSize",
      searchTerm: "filters/searchTerm", // for future search functionality
      selections: "filters/selections",
      searchParams: "filters/searchParams",
      trimsAndAccessories: 'trimsAccessories/trimsAndAccessories',
    }),
    changedData() {
      return `${this.sortOrder}|${this.selectedFilters}|${this.isAscendingOrder}`;
    }
  },
  methods: {
    ...mapActions({
      fetchTrimsAndAccessories: 'trimsAccessories/fetchTrimsAndAccessories',
      fetchResults: 'trimsAccessories/fetchResults',
      setPageNumber: 'trimsAccessories/setPageNumber',
      setInitialSelectedFilters: 'filters/setInitialSelectedFilters',
      setSearchTerm: 'filters/setSearchTerm',
      setFiltersFromURL: 'filters/setFiltersFromURL',
      setFiltersInURL: 'filters/setFiltersInURL'
    }),
    onLoadMore() {
      if (this.isFetching) {
        return;
      }
      this.setPageNumber(this.pageNumber + 1);
      this.onSearch();

      const urlSearchParams = new URLSearchParams(window.location.search);
      if (!urlSearchParams.has('searchTerm')) this.trackProductContainerHeights();
    },
    async onSearch() {
      await this.fetchTrimsAndAccessories({
        filter: this.getFilterObject()
      });
    },
    getFilterObject() {
      return {
        ...this.selections,
        PageNumber: this.pageNumber,
        IncludeTotalResultCount: true,
        PageSize: this.pageSize,
        SearchTerm: this.searchTerm,
        IsAscendingOrder: this.isAscendingOrder === "asc",
        IsEnabledOnSite: true,
        IsDisabledOnSearch: false,
      };
    },
    updateURl(param, value) {
      const url = new URL(window.location.href);
      url.searchParams.set(param, value);
      window.history.replaceState({}, "", url);
    },

    //TODO
    trackPageNumberInURL() {

      // Track the current page number in the URL based on the scroll position of the page
      if (this.containerHeights && this.containerHeights.length > 0) {
        const scrollPosition = window.scrollY;
        // Find the index of the first element in containerHeights that is greater than the current scroll position
        const index = this.containerHeights.findIndex(height => scrollPosition < height);
        // If an appropriate index is found and it is different from the current index, update the current index and the URL
        if (index >= 0 && this.currentHeightIndex !== index) {
          this.currentHeightIndex = index;
          this.updateURl("Page", this.currentHeightIndex + 1);
        }
      }
    },
    //TODO
    trackProductContainerHeights() {
      const resultsContainer = document.getElementById('vue-wf-product-category');

      if (resultsContainer) {
        let resultsContainerHeight = resultsContainer.clientHeight;

        // Check if new height is within range of existing height values
        let withinRange = false;
        for (let i = 0; i < this.containerHeights.length; i++) {
          if (Math.abs(this.containerHeights[i] - resultsContainerHeight) < 1000) {
            withinRange = true;
            break;
          }
        }

        this.containerHeights.push(resultsContainerHeight);
        this.containerHeights.sort((a, b) => a - b);
        sessionStorage.setItem('containerHeights', JSON.stringify(this.containerHeights));
      }
    },
    //TODO
    async scrollToLastPosition() {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const ProductId = urlSearchParams.get('ProductId');
      const lastScrollPosition = window.scrollY;
      // Create a promise that resolves when the product data is loaded
      const productDataPromise = new Promise((resolve) => {
        const checkProductData = setInterval(() => {
          const products = document.getElementsByClassName('wf-search-result description');
          if (products.length > 0) {
            clearInterval(checkProductData);
            resolve(products);
          }
        }, 1000);
      });
      // Wait for the promise to resolve before scrolling to the last position
      const products = await productDataPromise;
      const matchingProduct = Array.from(products).find((product) => product.id === ProductId);
      if (matchingProduct) {
        const top = matchingProduct.getBoundingClientRect().top + lastScrollPosition;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    },
    learnMore(item) {
      if (item.tearSheetLink) {
        window.open(item.tearSheetLink, '_blank');
      }
    },
    specSheet(item) {
      if (item.specSheetLink) {
        window.open(item.specSheetLink, '_blank');
      }
    },
    contactManager() {
      window.location.href = '/RepLocator';
    },
    setCurrentColorNumber(colorNumber) {
      this.currentColorNumber = colorNumber;
    },
    onSlideChange(index) {
      const item = this.trimsAndAccessories[index];
      if (item && item.trimColors) {
        const slideIndex = item.trimColors.findIndex(c => c.colorNumber === this.currentColorNumber);
        this.setCurrentColorNumber(item.trimColors[slideIndex].colorNumber);
      }
    },
  },
  mounted() {
    const currentURL = window.location.search;
    const defaultTrimsURL = '?sortOrder=SellingStyleName&isAscendingOrder=asc';
    if (!currentURL.includes('?')) {
      window.location.href = defaultTrimsURL;
    }

    const element = document.getElementById("wf-product-display-control-sort-by");
    if (element && element.scrollIntoView) {
      element.scrollIntoView({ behavior: "smooth" });
    }

    if (this.searchParams) { this.setFiltersFromURL(); }

    if (this.initialSelectedFilters) {
      this.setInitialSelectedFilters(
        Object.fromEntries(
          Object.entries(JSON.parse(this.initialSelectedFilters)).map(
            ([k, v]) => [k[0].toUpperCase() + k.slice(1), v]
          )
        )
      );
    }

    //TODO
    // const containerHeightsString = sessionStorage.getItem('containerHeights');
    // if (containerHeightsString) {
    //   this.containerHeights = [];
    //   this.containerHeights = JSON.parse(containerHeightsString);
    // }

    // window.addEventListener('scroll', this.trackPageNumberInURL);
    // this.scrollToLastPosition();
    initialize();

  },
  watch: {
    changedData: {
      handler: function () {
        this.setPageNumber(1);
        this.onSearch();
        this.setFiltersInURL("OriginalActivationDate");
      },
      deep: true,
    },
  },
};
</script>

